const dashboardMenu = [
    {
        "label": "DASHBOARD",
        "link": "/dashboard",
        // "icon": "ri-pie-chart-2-fill"
        "icon": "ri-shopping-bag-3-line"
    }
]

const automationMenu = [
    {
        "label": "UPDATE BULK PRICE",
        "link": "/automation/bulk-price-update",
        "icon": "ri-price-tag-2-line"
    }
]

const deliveryAppMenu = [
    {
        "label": "FOOD DELIVERY APP",
        "link": "/delivery-app/food-delivery-app",
        "icon": "ri-e-bike-2-line"
    }
]

const eventsMenu = [
    {
        "label": "EVENTS",
        "link": "/events",
        "icon": "ri-calendar-2-line"
    }
]

const mastersMenu = [
    // {
    //     "label": "ASSET TYPE",
    //     "link": "/masters/asset-type",
    //     "icon": "ri-newspaper-fill",
    // },
    {
        "label": "LEVEL",
        "link": "/masters/level",
        "icon": "ri-sort-asc",
    },
    // {
    //     "label": "UNIVERSAL ADDONS",
    //     "link": "/menu/uni-menu-addon",
    //     "icon": "ri-menu-fold-fill"
    // },
    {
        "label": "MENU GROUP",
        "link": "/masters/menu-group",
        "icon": "ri-list-check-2"
    },
    {
        "label": "MENU PRICING",
        "link": "/masters/menu-pricing",
        "icon": "ri-wallet-2-fill"
    },
    {
        "label": "STORAGE LOCATION",
        "link": "/masters/storage-location",
        "icon": "ri-map-pin-fill"
    },
    {
        "label": "VENDORS",
        "link": "/masters/vendors",
        "icon": "ri-shield-user-line"
    }
]

const outletsMenu = [
    {
        "label": "OUTLET MGT",
        "link": "/outlet-management/outlets",
        "icon": "ri-home-gear-fill"
    },
    {
        "label": "OUTLET USER MGT",
        "link": "/outlet-management/outlet-users",
        "icon": "ri-shield-user-line"
    },
    {
        "label": "KIOSK USER MGT",
        "link": "/outlet-management/kiosk-outlet-users",
        "icon": "ri-map-pin-user-line"
    },
    {
        "label": "PETTY CASH",
        "link": "/outlet-management/petty-cash",
        "icon": "ri-wallet-2-line"
    }
]

const requestsIntendMenu = [
    {
        "label": "BEVERAGE REQUEST",
        "link": "/request-intend/beverage-request",
        "icon": "ri-ink-bottle-line"
    },
    {
        "label": "CENTRAL REQUEST",
        "link": "/request-intend/central-request",
        "icon": "ri-government-fill"
    },
    {
        "label": "FOOD REQUEST",
        "link": "/request-intend/food-request",
        "icon": "ri-function-line"
    },
]

const menu = [
    {
        "label": "CREATE PRODUCT",
        "link": "/menu/product-creation",
        "icon": "ri-add-box-line",
    },
    {
        "label": "CATEGORY MGT",
        "link": "/menu/category",
        "icon": "ri-checkbox-multiple-line",
    },
    {
        "label": "NEW ARRIVALS",
        "link": "/menu/new-arrivals",
        "icon": "ri-shield-star-line"
    },
    {
        "label": "ADD MENU",
        "link": "/menu/add-menu",
        "icon": "ri-restaurant-fill"
    },
    {
        "label": "MENU CATALOG",
        "link": "/menu/menu-catalog",
        "icon": "ri-restaurant-2-line"
    },
    {
        "label": "MENU INGREDIENTS",
        "link": "/menu/menu-ingredients",
        "icon": "ri-search-2-fill"
    },
    {
        "label": "MENU GROUP",
        "link": "/masters/menu-group",
        "icon": "ri-todo-line"
    },
    {
        "label": "MENU PRICING",
        "link": "/masters/menu-pricing",
        "icon": "ri-wallet-2-fill"
    },
    // {
    //     "label": "OLD MENU ADDONS",
    //     "link": "/menu/menu-addons",
    //     "icon": "ri-stack-line"
    // },
    {
        "label": "ADDON GROUPS",
        "link": "/menu/menu-addon",
        "icon": "ri-list-check-2"
    },
    {
        "label": "ADDON ALLOCATION",
        "link": "/menu/product-addon-allocation",
        "icon": "ri-share-forward-2-line"
    }
    
]

const PurchaseMenu = [
    // {
    //     "label": "ADD PURCHASE",
    //     "link": "/purchase/add-purchase",
    //     "icon": "ri-add-box-line",
    // },
    // {
    //     "label": "STOCK REQUEST",
    //     "link": "/purchase/stock-request",
    //     "icon": "ri-git-pull-request-line",
    // },
    {
        "label": "STOCK REQUEST",
        "link": "/purchase/stocks-request",
        "icon": "ri-git-pull-request-line",
        "showBadge": true, // Add this flag
    },
    {
        "label": "PURCHASE LIST",
        "link": "/purchase/purchase-list",
        "icon": "ri-file-list-line",
    },
    {
        "label": "LOCAL PROCUREMENT",
        "link": "/purchase/local-procurement",
        "icon": "ri-honour-line",
    },
    {
        "label": "PURCHASE UNITS",
        "link": "/purchase/purchase-units",
        "icon": "ri-layout-grid-line",
    },
    {
        "label": "OUTLET STOCK TRANSFER",
        "link": "/purchase/outlet-stock-transfer",
        "icon": "ri-store-line",
    },
    {
        "label": "STORAGE LOCATION ST TRANSFER",
        "link": "/purchase/storage-location-stock-transfer",
        "icon": "ri-database-line",
    },
    {
        "label": "RM DAMAGE ENTRIES",
        "link": "/purchase/rm-damage-entries",
        "icon": "ri-file-damage-fill",
    },
    // {
    //     "label": "RM STOCK REPORT",
    //     "link": "/purchase/rm-stock-report",
    //     "icon": "ri-file-chart-line",
    // },
]

const CustomerSupportMgt = [
    {
        "label": "CUSTOMER SUPPORT MGT",
        "link": "/customer-support-mgt",
        "icon": "ri-customer-service-line"
    }
]

const CancellationRequest = [
    {
        "label": "CANCELATION REQUEST",
        "link": "/cancelation-request",
        "icon": "ri-close-circle-line"
    }
]

const FranchiseEnquiryMenu = [
    {
        "label": "FRANCHISE ENQUIRY",
        "link": "/franchise-enquiry",
        "icon": "ri-store-3-line"
    }
]

const contentMgtMenu = [
    {
        "label": "ADVERTISEMENT MGT",
        "link": "/content-management/advertisement-mgt",
        "icon": "ri-advertisement-fill"
    },
    {
        "label": "POPUP ADVERTISEMENT",
        "link": "/content-management/popup-advertisement",
        "icon": "ri-picture-in-picture-2-fill"
    },
    {
        "label": "PROMOTE PRODUCTS",
        "link": "/content-management/promote-products",
        "icon": "ri-price-tag-line"
    },
    // {
    //     "label": "NOTIFICATION SCHEDULER",
    //     "link": "/content-management/notification-scheduler",
    //     "icon": "ri-notification-line"
    // }
]

const notificationsMenu = [
    { 
        "label": "BROADCAST SCHEDULER",
        "link": "/notifications/broadcast",
        "icon": "ri-broadcast-line"
    },
    {
        "label": "CART SCHEDULER",
        "link": "/notifications/cart-scheduler",
        "icon": "ri-shopping-cart-2-line"
    },
    {
        "label": "NOTIFICATION SCHEDULER",
        "link": "/notifications/notification-scheduler",
        "icon": "ri-notification-line"
    },
]

const couponsMenu = [
    // {
    //     "label": "CREATE COUPON",
    //     "link": "/coupons/create-coupon",
    //     "icon": "ri-coupon-5-line"
    // },
    {
        "label": "COUPONS",
        "link": "/coupons/coupons-list",
        "icon": "ri-coupon-2-line"
    },
    {
        "label": "AUTO COUPON ALLOCATION",
        "link": "/coupons/auto-coupon-allocation",
        "icon": "ri-coupon-fill"
    },
    // {
    //     "label": "OFFER FOR DAY",
    //     "link": "/coupons/offer-of-the-day",
    //     "icon": "ri-medal-fill"
    // },
    {
        "label": "USER COUPON ALLOCATION",
        "link": "/coupons/user-coupon-allocation",
        "icon": "ri-user-shared-line"
    }
]

const systemMenu = [
    {
        "label": "APP VERSION",
        "link": "/system-preference/version-control",
        "icon": "ri-remote-control-2-line"
    },
    {
        "label": "SETTINGS",
        "link": "/system-preference/settings",
        "icon": "ri-settings-2-line"
    },
    {
        "label": "LOGS",
        "link": "/system-preference/logs",
        "icon": "ri-logout-circle-r-line"
    }
]

const reportsMenu = [
    {
        "label": "ALL REPORTS",
        "link": "/reports/all-reports",
        "icon": "ri-file-chart-line",
    },
    // {
    //     "label": "CUSTOMERS REPORT",
    //     "link": "/reports/customer-reports",
    //     "icon": "ri-file-user-line"
    // },
    // {
    //     "label": "ORDERS REPORT",
    //     "link": "/reports/order-reports",
    //     "icon": "ri-article-line"
    // },
    // {
    //     "label": "KIOSK USERS REPORT",
    //     "link": "/reports/kiosk-user-reports",
    //     "icon": "ri-macbook-line"
    // },
    // {
    //     "label": "USER ANALYTICS REPORT",
    //     "link": "/reports/user-analytics-reports",
    //     "icon": "ri-account-pin-circle-fill"
    // },
    // {
    //     "label": "COUPONS REPORT",
    //     "link": "/reports/coupons-report",
    //     "icon": "ri-coupon-3-fill"
    // },
    // {
    //     "label": "DAY SUMMARY REPORT",
    //     "link": "/reports/day-summary-report",
    //     "icon": "ri-slideshow-line"
    // },
    // {
    //     "label": "MONTH SUMMARY REPORT",
    //     "link": "/reports/month-summary-report",
    //     "icon": "ri-barcode-box-line"
    // },
    // {
    //     "label": "ADDON SALES REPORT",
    //     "link": "/reports/addon-sales-report",
    //     "icon": "ri-list-check-2"
    // },
    // {
    //     "label": "PRODUCT SALES REPORT",
    //     "link": "/reports/product-sales-report",
    //     "icon": "ri-product-hunt-line"
    // },
    // {
    //     "label": "ITEM WISE SALES REPORT",
    //     "link": "/reports/item-wise-report",
    //     "icon": "ri-pie-chart-box-line"
    // },
    // {
    //     "label": "USER COUPON REPORT",
    //     "link": "/reports/user-coupon-report",
    //     "icon": "ri-contacts-book-fill"
    // },
    // {
    //     "label": "RM REORDER LEVEL REPORT",
    //     "link": "/reports/rm-reorder-report",
    //     "icon": "ri-git-pull-request-line"
    // }
]

const transactionsMenu = [
    {
        "label": "CENTRAL STK TRANS",
        "link": "/transaction/central-stock-report",
        "icon": "ri-wallet-2-line"
    },
    {
        "label": "OUTLET STK TRANS",
        "link": "/transaction/outlet-stock-report",
        "icon": "ri-store-3-line"
    }
]

const userLevelMenu = [
    {
        "label": "LEVEL",
        "link": "/masters/level",
        "icon": "ri-sort-asc",
    },
    {
        "label": "ADD LEVEL REWARD",
        "link": "/user-level/add-level-reward",
        "icon": "ri-gift-line"
    },
    {
        "label": "VIEW LEVEL REWARDS",
        "link": "/user-level/view-level-reward",
        "icon": "ri-gift-fill"
    }
]

const materialMgtMenu = [
    {
        "label": "RAW MATERIALS",
        "link": "/material-mgt/raw-materials",
        "icon": "ri-archive-drawer-line"
    },
    {
        "label": "RM SUB CATEGORY",
        "link": "/material-mgt/rm-sub-category",
        "icon": "ri-file-copy-2-line"
    },
    {
        "label": "RM MAIN CATEGORY",
        "link": "/material-mgt/rm-main-category",
        "icon": "ri-article-fill"
    },
    {
        "label": "STORAGE LOCATION",
        "link": "/masters/storage-location",
        "icon": "ri-map-pin-fill"
    },
    {
        "label": "VENDORS",
        "link": "/masters/vendors",
        "icon": "ri-shield-user-line"
    }
]

const assetMgtMenu = [
    {
        "label": "ASSET STOCK TRANSFER",
        "link": "/asset-mgt/asset-stock-transfer",
        "icon": "ri-send-plane-2-line"
    }
]

const subscriptionMenu = [
    {
        "label": "CREATE SUBSCRIPTION",
        "link": "/subscription/add-subscription",
        "icon": "ri-gift-2-line"
    },
    {
        "label": "SUBSCRIPTIONS",
        "link": "/subscription/view-subscription",
        "icon": "ri-voice-recognition-line"
    },
    // {
    //     "label": "PURHCASE REPORT",
    //     "link": "/subscription/subscription-users",
    //     "icon": "ri-user-star-line"
    // },
    // {
    //     "label": "CONSUMPTION REPORT",
    //     "link": "/subscription/subscription-consumption-report",
    //     "icon": "ri-refund-line"
    // }
]

const summariesMenu = [
    {
        "label": "ORDER SUMMARY",
        "link": "/summaries/order-summary",
        "icon": "ri-dvd-line"
    },
    {
        "label": "ITEM WISE SUMMARY",
        "link": "/summaries/item-wise-summary",
        "icon": "ri-dvd-line"
    },
    {
        "label": "ADDON SALES SUMMARY",
        "link": "/summaries/addon-sales-summary",
        "icon": "ri-dvd-line"
    },
    {
        "label": "COUPON USAGE SUMMARY",
        "link": "/summaries/coupon-usage-summary",
        "icon": "ri-dvd-line"
    }
]

const supportMenu = [
    {
        "label": "CUSTOMER SUPPORT MGT",
        "link": "/customer-support-mgt",
        "icon": "ri-customer-service-line"
    },
    {
        "label": "CANCELATION REQUEST",
        "link": "/cancelation-request",
        "icon": "ri-close-circle-line"
    },
    {
        "label": "FRANCHISE ENQUIRY",
        "link": "/franchise-enquiry",
        "icon": "ri-store-3-line"
    }
]

const userMgtMenu = [
    {
        "label": "User Mgt",
        "link": "/admin-user-mgt/user-mgt",
        "icon": "ri-user-settings-fill"
    },
    // {
    //     "label": "ROLES",
    //     "link": "/admin-user-mgt/roles",
    //     "icon": "ri-map-pin-range-line",
    // },
]

export { dashboardMenu, mastersMenu, outletsMenu, menu, contentMgtMenu, couponsMenu, systemMenu, automationMenu, CustomerSupportMgt, CancellationRequest, PurchaseMenu, reportsMenu, transactionsMenu, userLevelMenu, materialMgtMenu, assetMgtMenu, FranchiseEnquiryMenu, subscriptionMenu, summariesMenu, userMgtMenu, supportMenu, requestsIntendMenu, deliveryAppMenu, notificationsMenu, eventsMenu }